import AboutRow from './Row'

export default AboutRow
